import { useState, useContext } from "react";
import styled from "styled-components";
import isEmpty from "lodash.isempty";
import { MediaQueries } from "@paclife/plds.tokens";

import Navigation from "common/Navigation/Navigation";
import Loading from "common/Loading/Loading";
import { AppContext } from "context/AppContext";

const MOBILE_HEADER_HEIGHT = "80px";

const Wrapper = styled.div`
    @media (min-width: ${MediaQueries.md}) {
        display: flex;
    }
`;

const Main = styled.main`
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    @media (max-width: ${MediaQueries.md}) {
        height: calc(100vh - ${MOBILE_HEADER_HEIGHT});
    }
`;

const menu = [{ name: "My Profile", icon: "avatar", path: "/" }];

function Layout({ children }) {
    const [collapsed, setCollapsed] = useState(false);
    const { personal } = useContext(AppContext);

    if (isEmpty(personal)) {
        return <Loading height="100vh" />;
    }
    return (
        <Wrapper>
            <Navigation
                firstName={personal.firstName}
                lastName={personal.lastName}
                subtitle=""
                menu={menu}
                collapsed={collapsed}
                setCollapsed={setCollapsed}
            />
            <Main>{children}</Main>
        </Wrapper>
    );
}

export default Layout;
